import React, { useCallback, useState } from 'react'
import { FormGroup, Label } from 'reactstrap'
import Resx from '@/components/Resx'
import { Validator } from '@/components/validation'
import { NumericInput } from '@/components/inputs'
import * as PropTypes from 'prop-types'

function emptyValidValidate ({ value }) {
  if (!value.toString().match('\\S')) {
    return 'CodeLists.EmptyString'
  }
}

function CompanyClassInputs (props) {
  const [value, setValue] = useState(props.value || 0)

  const handleChange = useCallback((e) => {
    setValue(e)
    props.onChange(e)
  }, [props])

  return <FormGroup>
    <Label><Resx name='Tickets.InstitutionMinimum' />:</Label>
    <Validator name='minimumInstitutions' value={value} onValidate={emptyValidValidate} required>
      <NumericInput integerOnly min={0} value={value} onChange={handleChange} />
    </Validator>
  </FormGroup>
}

CompanyClassInputs.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any
}
export default CompanyClassInputs



// WEBPACK FOOTER //
// ./src/components/codeLists/companyClassInput.js